import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=372e4ac6&scoped=true&lang=pug&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=372e4ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e4ac6",
  null
  
)

export default component.exports